import { gql } from '@apollo/client'

export const FEEDBACKS_QUERY = gql`
  query feedbacks($page: Int, $limit: Int, $filter: FeedbackFilter, $sortBy: FeedbackSort) {
    feedbacks(page: $page, limit: $limit, filter: $filter, sortBy: $sortBy) {
      collection {
        id
        comments
        feedbackTypeId
        feedbackType {
          title
          id
        }
        origin
        feedbackResolved
        possibleSolution
        processing {
          assignedProcessingType {
            category
          }
          actualProcessingType {
            category
          }
          agentId
          agent {
            name
            costCentre
          }
          caseId
          closedAt
          closedByRsv
          closedByM2
          closingType {
            title
          }
          fileNumber
          costsSettledWithRsvAt
          costsSettledWithOperatorAt
          firstCallAt
          acceptedAt
          rsvBillable
          rsvNonBillableReason
          invoice {
            invoiceNo
            invoiceSum
          }
          id
          m2Case {
            caseState
            assignedToM2At
            creator {
              name
            }
            policyholder {
              policyNumber
              firstname
              lastname
              email
            }
            id
            claimNumber
            insurance {
              title
            }
            processingsCount
            project {
              title
            }
            m2LegalArea {
              title
            }
            rsvLegalArea {
              title
            }
          }

          processingStep
          processingState
          result
          settlementRate
          settlementType {
            title
          }
        }
        processingId
        feedbackReceivedAt
        feedbackClosedAt
        feedbackChannel
        feedbackReason
        feedbackCategory
        additionalComments
        feedbackValid
        createdAt
        updatedAt
      }
      metadata {
        totalCount
        currentPage
      }
    }
  }
`
